(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      this.onArrowResize = this.updateArrowState.bind(this);
      this.arrowResizeObserver = typeof ResizeObserver === 'function'
        ? new ResizeObserver(this.onArrowResize)
        : null;

      this.isLoading = false;
    }

    connectedCallback() {
      if (this.classList.contains('products-loaded')) {
        this.observeArrowSizes();
      } else {
        this.loadRecommendations();
      }
    }

    async loadRecommendations() {
      if (this.isLoading || !this.dataset.url) return;
      this.isLoading = true;

      try {
        // Prepare the section on page load, even while it is below the viewport.
        const response = await fetch(this.dataset.url);
        if (!response.ok) throw new Error(`Product recommendations request failed: ${response.status}`);
        const text = await response.text();
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          // Images must not introduce a second scroll-dependent loading step.
          // Preserve their existing fetch priority so they do not displace the main product image.
          recommendations.querySelectorAll('img[loading="lazy"]').forEach((image) => {
            image.loading = 'eager';
          });
          this.innerHTML = recommendations.innerHTML;
        }

        this.classList.add('products-loaded');
        this.observeArrowSizes();
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    }

    disconnectedCallback() {
      this.arrowResizeObserver?.disconnect();
      window.removeEventListener('resize', this.onArrowResize);
    }

    observeArrowSizes() {
      this.arrowResizeObserver?.disconnect();
      if (!this.isConnected) return;

      const track = this.querySelector('gridy-slider .gridy-track');
      if (track && this.arrowResizeObserver) {
        this.arrowResizeObserver.observe(track);
        Array.from(track.children).forEach((slide) => this.arrowResizeObserver.observe(slide));
      } else if (!this.arrowResizeObserver) {
        window.addEventListener('resize', this.onArrowResize);
      }
      this.updateArrowState();
    }

    updateArrowState() {
      if (!this.isConnected) return;
      const slider = this.querySelector('gridy-slider');
      const track = slider?.querySelector('.gridy-track');
      const arrows = slider?.querySelector('.gridy-arrows');
      if (!track || !arrows) return;

      const overflowX = window.getComputedStyle(track).overflowX;
      const canScroll = track.clientWidth > 0
        && (overflowX === 'auto' || overflowX === 'scroll')
        && track.scrollWidth - track.clientWidth > 1;

      // Actual rendered overflow takes over from the initial Liquid count hint.
      arrows.classList.remove('md-hide', 'sm-to-md-hide', 'sm-down-hide');
      arrows.hidden = !canScroll;
      arrows.querySelectorAll('[data-gridy-arrow]').forEach((button) => {
        button.disabled = !canScroll;
      });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
